<template>

    <gj-modal
        v-bind="$attrs"
        v-on="$listeners"
        :visible.sync="modalVisible"
        :destroyOnClose="true"
        :footer="false"
        size="full-screen"
        @open="modalOpen"
        :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
    >
      <template #header>
        <span>匹配订单</span>
      </template>
      <template #content>
        <div style="flex: 1; overflow: auto; display: flex; flex-direction: column">
          <div class="flex justify-between align-center" style="margin-top: 12px;margin-bottom: 12px">
            <div>
              <span class="l-title">匹配订单推荐列表</span>
              <gj-button class="l-btn" type="primary" @click="openBatchOrder">添加匹配订单</gj-button>
              <span class="size12 color999" style="margin-left: 16px;">同一订单编号若NF邮件中任务已存在，则不会生成NR邮件任务</span>
            </div>
            <gj-dropdown trigger="click">
              <gj-button size="mini" class="dropdown-btn" :disabled="noSelect">
                批量操作
              </gj-button>
              <template #dropdown>
                <gj-dropdown-item @click="batchHandle('1','生成邮件')">生成邮件</gj-dropdown-item>
                <gj-dropdown-item @click="batchHandle('2','删除')">删除</gj-dropdown-item>
                <gj-dropdown-item @click="batchHandle('3','关闭')">关闭</gj-dropdown-item>
                <gj-dropdown-item @click="batchHandle('4','开启邮件')">开启邮件</gj-dropdown-item>
                <gj-dropdown-item @click="batchHandle('5','标记处理')">标记处理</gj-dropdown-item>
              </template>
            </gj-dropdown>
          </div>
          <gj-table
              ref="gjTable"
              name="recommendTable"
              adaptParent
              :loading="modalLoading.recommendOrder"
              :data="recommendOrderTableData"
              :columns="recommendOrderColumns"
              :index="false"
              selection
              :offset-height="18">
            <template v-slot:matchResult="{row}">
               <span style="color: red" v-if="row.matchResult === '错误'">{{row.matchResult}}</span>
               <span v-else>{{row.matchResult}}</span>
            </template>
            <template v-slot:buyerName="{row}">
              <div v-if="row.nameType === 'buyerName'">
                <div v-html="row.splitBuyerName"></div>
              </div>
              <div v-else>
                {{ row.buyerName }}
              </div>
            </template>
            <template v-slot:addressName="{row}">
              <div v-if="row.nameType === 'addressName'">
                <div v-html="row.splitAddressName"></div>
              </div>
              <div v-else>
                {{ row.addressName }}
              </div>
            </template>

            <template v-slot:status="{row}">
              {{ row.status| optionText(reviewDetailStatusOption) }}
            </template>

            <template v-slot:op="{row}">
<!--              <gj-button-group v-if="$permission('review:matchOrRemoveOrder') && !row.matchResult" type="dropdown-op">-->
<!--                <gj-button type="primary" size="mini" @click="match(row, 1)">采纳</gj-button>-->
<!--                <gj-button plain size="mini" @click="match(row, 0)">不采纳</gj-button>-->
<!--              </gj-button-group>-->
              <gj-button-group type="dropdown-op">
                <gj-button type="text" v-if="row.status==='waiting'||row.status==='processing'||row.status==='finished'" :disabled="type==='email'" :loading="row.singleLoading" @click="lookEmail(row.reviewRelateOrderId,row)">查看邮件</gj-button>
                <gj-button type="text" v-if="row.status==='nothing'" @click="singleHandle('1',row.reviewRelateOrderId,'生成邮件',row)" :loading="row.singleLoading">生成邮件</gj-button>
                <gj-button type="text" v-if="row.status==='nothing'" @click="singleHandle('2',row.reviewRelateOrderId,'删除')">删除</gj-button>
                <gj-button type="text" v-if="row.status==='waiting'" @click="singleHandle('3',row.reviewRelateOrderId,'关闭')">关闭</gj-button>
                <gj-button type="text" v-if="row.status==='closed'" @click="singleHandle('4',row.reviewRelateOrderId,'开启邮件',row)" :loading="row.singleLoading">开启邮件</gj-button>
                <gj-button type="text" v-if="row.status==='processing'" @click="singleHandle('5',row.reviewRelateOrderId,'标记处理')">标记处理</gj-button>
              </gj-button-group>
            </template>
          </gj-table>
        </div>
      </template>
    </gj-modal>

</template>

<script>
import {modalMixIn, selectionMixin} from "@/minxins";
import AppReviewBatchMatchOrder from "@/views/modules/sale/review/modal/review-batch-match-order";
import MailModal from "@/views/modules/sale/review/modal/mail-modal";
import {isMeaningful, isMeaningless} from "@/utils/common";
import {
  getReviewDetail, //详情
  operateAdopt, //采纳
  getMatchOrderList,//列表
  batchOperationEmail,//批量操作
  singleOperationEmail,//单个操作
} from "@/api/sale";
import {
  trackingResultsOption
} from "@/utils/options";
import {
  getMailList,//获取邮件
  getEmailAccountCombobox
} from "@/api/crm";
import {mapGetters} from "vuex";
import {optionText} from "@/filters";
import {countryOption} from "@/utils/options";
import {disableMarket} from "@/api/system";
import SaleOrderDetail from "@/views/modules/sale/saleOrder/modal/sale-order-detail";

export default {
  name: "app-review-detail",
  mixins: [modalMixIn,selectionMixin],
  props: {
    id: {
      require: true,
    },
    //有值时代表从邮件打开，禁用查看邮件按钮
    type:null
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption',
      markets: 'authMarkets'
    }),
  },
  created() {
    // 获取详情数据
    this.modalLoading.detail = true;
    this.getReviewDetail();
    this.reviewDetailOrder();
    // 获取匹配订单
  },
  mounted() {
    getEmailAccountCombobox().then(res=>{
      //邮箱--对应店铺列表
      this.marketOptions = this.markets.map(m => {
        let r = res.filter(r => r.marketId === m.id)[0];
        if (r) {
          return {
            mailId:r.id,
            ...r,
            ...m,
            status:r.status
          }
        }else {
          return m
        }
      });
    })
  },
  data() {
    return {
      trackingResultsOption,
      modalLoading: {
        detail: false,
        matchOrder: false,
        recommendOrder: false,
        batchOrder: false,
      },
      modalVisibleDetail: {
        batchOrder: false
      },
      detailData: {},
      matchOrderTableData: [],
      recommendOrderColumns: [
        {id: 'marketId', header: '店铺', field: 'option:marketId', options: () => this.marketOption, minWidth: '100px', default: true},
        {id: 'orderId', header: '订单编号', field: 'orderId', minWidth: '120px', copyable: true, default: true},
        {id: 'matchResult', header: '匹配结果', field: 'slot:matchResult', minWidth: '100px', copyable: true, default: true},
        {id: 'matchType', header: '匹配方式', field: 'matchType', minWidth: '90px', default: true},
        {id: 'buyerName', header: '买家姓名', field: 'slot:buyerName', minWidth: '120px', default: true},
        {id: 'addressName', header: '收货人姓名', field: 'slot:addressName', minWidth: '120px', default: true},
        {id: 'buyerEmail', header: '买家邮箱', field: 'buyerEmail', minWidth: '220px', default: true},
        {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '110px', default: true},
        {id: 'status', header: '状态', field: 'slot:status', minWidth: '80px', default: true},
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '135px', default: true, notCustomColumn: true}
      ],
      recommendOrderTableData: [],
      reviewDetailStatusOption: [
        {id: 'nothing', text: '-'},
        {id: 'waiting', text: '待处理'},
        {id: 'processing', text: '处理中'},
        {id: 'finished', text: '已完成'},
        {id: 'closed', text: '已关闭'},
      ]
    }
  },
  methods: {
    getReviewDetail(){
      getReviewDetail(this.id).then(detailData => {
        this.detailData = detailData;
        // 查询匹配订单
      }).complete(() => this.modalLoading.detail = false);
    },
    isMeaningful,
    //点击关联订单打开订单详情
    opOrderDetail(marketId, orderId) {
      this.$gjCreate(SaleOrderDetail, {
        props: {
          marketId: marketId,
          orderId: orderId,
        }
      })
    },
    getLastResult(val){
      if(val){
        return this.trackingResultsOption.find(r=>r.id===val).text
      }else {
        return '-'
      }
    },
    //查看邮件
    lookEmail(reviewRelateOrderId,row){
      if(row){
        row.singleLoading = true;
      }

      getMailList({model:{reviewRelateOrderId:reviewRelateOrderId}}).then(res=>{
        res.records[0].uploadAttFiles=[];
        this.$gjCreate(MailModal, {
          mountTo: document.getElementById('gj-base-main'),
          props: {
            emailItem:res.records[0],
            marketOptions:this.marketOptions || []
          },
          on: {
            close: () => {
              this.getReviewDetail();
              this.reviewDetailOrder();
            }
          }
        });
        this.$emit('changeData');
      }).complete(()=>{
        if(row){
          row.singleLoading = false;
        }
      })

    },
    //批量操作弹框
    batchHandle(type,typeStr){
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: typeStr+'提示',
          content: `是否确定批量${typeStr}？`
        },
        on: {
          confirm: () => {
            this.batch(type)
            modal.$gjDestroy()
          },
          cancel: () => {
            modal.$gjDestroy()
          }
        }
      });
    },
    //批量操作
    batch(type){
      let params = {
        relateOrderIdList:this.selectedRows.map(r => r.reviewRelateOrderId),
        type:type
      }
      batchOperationEmail(params).then(res => {
        if(res.indexOf('操作成功')>-1){
          this.$gjMessage.success('操作成功');
        }else {
          const modal = this.$gjCreate('gj-info-modal', {
            props: {
              title: '反馈',
              content: res
            },
            on: {
              confirm: () => {
                modal.$gjDestroy()
              }
            }
          });
        }
        this.$emit('changeData');
        //刷新匹配订单列表
        this.reviewDetailOrder();
      })
    },
    //单项操作弹框
    singleHandle(type,reviewRelateOrderId, typeStr,row){
      if(type === '1'||type === '4'){
        row.singleLoading = true;
        //生成邮件、开启邮件
        this.opHandle(type,reviewRelateOrderId,row)
        return
      }
      let content;
      if(type === '2'){
        content = `是否确定删除?`
      }
      else if(type === '3'){
        content = `确认关闭，则此条邮件将自动删除，再次生成邮件任务可通过手动生成邮件，确认关闭吗？`
      }
      else if(type === '5'){
        content = `处理中的邮件进行标记处理，邮件状态将变为已完成，确认标记处理吗？<br>
                   <span style="color:#F5222D;">请谨慎使用此功能！！使用前确认邮件无买家回复！！</span>`
      }
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: typeStr+'提示',
          content: content
        },
        on: {
          confirm: () => {
            this.opHandle(type,reviewRelateOrderId)
            modal.$gjDestroy()
          },
          cancel: () => {
            modal.$gjDestroy()
          }
        }
      });
    },
    //单项操作
    opHandle(type,reviewRelateOrderId,row){
      singleOperationEmail(reviewRelateOrderId,type).then(res=>{
        this.$emit('changeData');
        // if(res.indexOf('操作成功')>-1){
          //刷新匹配订单列表
        this.reviewDetailOrder();

          if(type==='1'){
              let content;
              content = `${res}，是否查看邮件？`
              const modal = this.$gjCreate('gj-info-modal', {
                props: {
                  title: '反馈',
                  content: content,
                  type:'success'
                },
                on: {
                  confirm: () => {
                    this.lookEmail(reviewRelateOrderId)
                    modal.$gjDestroy()
                    // this.$router.push({
                    //   path:'/crm/mail-reply-manager',
                    //   query:{
                    //     type:'NR',
                    //     menuActive:'2'
                    //   }
                    // })
                  },
                  cancel: () => {
                    modal.$gjDestroy()
                  }
                }
              });
          }else {
            this.$gjMessage.success(`${res}`);
          }
        // }
      }).complete(()=>{
        if(row){
          row.singleLoading = false
        }
      })
    },
    // 采纳 或者 不采纳
    match(row, type) {
      const params = {
        id: this.id,
        marketId: row.marketId,
        orderId: row.orderId,
        purchaseDate: row.purchaseDate,
        adopt: type
      }
      operateAdopt(params).then(data => {
        this.$gjMessage.success("操作成功");
        this.$emit('changeData');
        this.reviewDetailOrder();
      });
    },
    // 匹配 名称 变色
    matchReplaceName(item, key) {
      let matchOriginName = item.matchOriginName.toLowerCase();
      if (item.workType === 'exact') {   // 精准匹配
        return `<span style="color:#1F6EEF;background: #EDF7FF;padding: 4px 1px;">${item[key]}</span>`;
      } else if (item.workType === 'word') {
        //  单词匹配
        let woldArr = item[key].split(' ').map(item=> item.toLowerCase()); // 找到第几个单词
        let findArr = woldArr.indexOf(matchOriginName.toLowerCase())
        if(findArr !== -1){
           let num = woldArr.slice(0, findArr).join('').length;
           return this.replaceToHtml(item[key], matchOriginName, num);
        }
        return this.replaceToHtml(item[key], matchOriginName, null);

      } else if (item.workType === 'wordGroup') {   // 词组匹配
        let nameMatchWordArray = matchOriginName.split(' ');
        let sumStr = '';
        nameMatchWordArray.forEach((word, index) => {
          if (index === 0) {
            sumStr = this.replaceToHtml(item[key], word, null);
          } else {
            sumStr = this.replaceToHtml(sumStr, word, null);
          }
        });
        return sumStr;
      } else if (item.workType === 'wordAndLetterFuzzy' || item.workType === 'wordAndLetter') { // 前置位单词+字母  单词+字母词组匹配
        let nameMatchWordArray = matchOriginName.split(' ');
        let sumStr = '';
        let pointIndex = 0;
        nameMatchWordArray.forEach((word, index) => {
          if (index === 0) {
            sumStr = this.replaceToHtml(item[key], word, null);
            pointIndex = item[key].toLowerCase().indexOf(word) + 73 + word.length; // 找到索引位置 + 拼接的长度
          } else {
            sumStr = this.replaceToHtml(sumStr, word, pointIndex);
            pointIndex = sumStr.toLowerCase().indexOf(word, pointIndex + 73) + word.length; //  顺延 从 已匹配后开始找
          }
        });
        return sumStr;
      }
    },
    // 替换 字符 为 HTML
    replaceToHtml(str, keyword, startIndex) {
      let srtEndIndex = 0, srtStartIndex = 0, newStr = '';
      srtStartIndex = str.toLowerCase().indexOf(keyword, startIndex);  // 开始的索引
      if (srtStartIndex === -1) {
        return str;
      }
      srtEndIndex = str.toLowerCase().indexOf(keyword, startIndex) + keyword.length;  // 结束位置的索引
      newStr = str.substring(0, srtEndIndex) + '</span>' + str.substring(srtEndIndex);
      newStr = newStr.substring(0, srtStartIndex) + '<span style="color:#1F6EEF;background: #EDF7FF;padding: 4px 1px;">' + newStr.substring(srtStartIndex);
      return newStr;
    },
    // 查询订单列表
    reviewDetailOrder() {
      this.modalLoading.recommendOrder = true;
      getMatchOrderList(this.id)
          .then(data => {
            data.forEach(item => {
              item.singleLoading = false; // 单项操作按钮loading状态
              if (item.matchOriginName) {
                if (item.nameType === "buyerName" && item.buyerName) {
                  item.splitBuyerName = this.matchReplaceName(item, 'buyerName');
                } else if (item.nameType === "addressName") {
                  item.splitAddressName = this.matchReplaceName(item, 'addressName');
                }
              }
            })
            this.recommendOrderTableData = data;

          }).complete(() => this.modalLoading.recommendOrder = false);
    },
    // 批量绑定订单
    openBatchOrder() {
      this.$gjCreate(AppReviewBatchMatchOrder, {
        props: {
          id: this.id,
          marketId: this.detailData.marketId,
        },
        on: {
          created: () => {
            this.$emit('changeData');
            this.reviewDetailOrder();
          }
        }
      })
    },
    handleClick() {
      const vm = this;
      this.$nextTick(() => vm.$nextTick(() => vm.recommendOrderTableData = [...vm.recommendOrderTableData]));
    }
  }
}
</script>

<style lang="scss" scoped>

.l-title {
  margin-top: 20px;
  font-size: 13px;
  color: #333333;
  line-height: 18px;
  font-weight: 600;

}

.l-btn {
  padding: 0 7px;
  font-size: 12px;
  height: 22px;
  border-radius: 2px;
  margin-left: 12px;
}

.label {
  text-align: right;
  padding-right: 12px;
}

.font16 {
  font-size: 16px;
}

.gj-mb6 {
  padding-bottom: 8px;
}

.match-order-message {
  padding: 16px 0;
}

.gj-label--color, .gj-content--color {
  font-size: 12px;
}

.gj-label--color {
  color: #666;
}

.gj-content--color {
  color: #333;
}

/deep/ .el-tabs__header {
  margin-bottom: 12px;
}

/deep/ .el-tabs__item.is-active {
  font-weight: bold;
}
/deep/ .wrapper-loading{
  flex: 1;
  overflow: auto;
}
.dropdown-btn{
  width: 90px;
  height: 30px;
}
</style>
